import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect as Redirecting,
} from 'react-router-dom';

import Index from './pages/Index';
import Redirect from './pages/Redirect';
import Main from './pages/Main';
import Logout from './pages/Logout';

import {
  validateCredentials,
  refreshBoxToken,
} from './utils/api';

const authenticate = async () => {
  const response = await validateCredentials();
  return response;
};

const checkSesssion = async (setSessionExpiredModalOpen) => {
  const tokenRefreshed = await refreshBoxToken();
  if (tokenRefreshed === false) {
    console.log('session expired');
    setSessionExpiredModalOpen(true);
  } else {
    console.log('refreshed session token');
  }
}

function PrivateRoute({ component: Page, ...rest }) {
  const [auth, setAuth] = useState(true);
  const [sessionExpiredModalOpen, setSessionExpiredModalOpen] = useState(false);

  useEffect(() => {
    let refreshTokenTimer = null;

    async function checkUser() {
      const res = await authenticate();
      setAuth(res);

      // attempt to get a new access token before current one epxires.
      // at some point, server will decide the current
      // session has been active too long and not return
      // a valid token at  which point, the user must reauthenticate
      if (res === true) { 
        refreshTokenTimer = setInterval(checkSesssion.bind(null, setSessionExpiredModalOpen), 3600*1000-60000);
      }
    }

    checkUser();

    // clear periodic token refresh timer function
    return function clearRefreshTokenTimer() {
      if (refreshTokenTimer !== null) {
        clearInterval(refreshTokenTimer);
      }
    }
  }, []);

  return (
    <Route
      {...rest}
      render={props =>
        auth ? <Page {...props.rest} sessionExpiredModalOpen={sessionExpiredModalOpen} /> : (
          <Redirecting to="/" />
        )
      }
    />
  );
}

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
};

export default function App() {
  return (
    <Router basename="/clientportal">
      <Switch>
        <Route exact path="/" component={Index} />
        <Route path="/redirect" component={Redirect} />
        <Route exact path="/logout" component={Logout} />
        <PrivateRoute exact path="/main" component={Main} />
        <Redirect to="/" />
      </Switch>
    </Router>
  );
}
